import { Component, OnInit } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";
import { AuthService } from "src/app/auth/auth.service";
import {
  SaveAdministrativeUnitSurveyMessage,
  AdministrativeUnitSurveyMessage,
} from "src/app/shared/models/survey";
import { NotificationService } from "src/app/shared/services/notification.service";
import { PublicSurveyService } from "src/app/shared/services/public-survey.service";
import { SurveyService } from "src/app/shared/services/survey.service";

@Component({
    // tslint:disable-next-line:component-selector
    selector: "formly-field-surveycommunicationsummary",
    template: `<communication-summary
    [survey]="model"
    [question]="props.question"
    [badges]="badges"
    (saveAdministrativeUnitSurveyMessage)="onSaveAdministrativeUnitSurveyMessage($event)"
  ></communication-summary>`,
    standalone: false
})
export class FormlyFieldCommunicationSummaryComponent
  extends FieldType<FieldTypeConfig>
  implements OnInit
{
  badges: any = {
    "lea-messages": 0,
    "internal-notes": 0,
    "submission-history": 0,
    "action-required-comments": 0,
  };

  get messages() {
    return this.model.administrativeUnitSurvey?.messages || this.model.messages || [];
  }

  get administrativeUnitSurveyHistories() {
    return (
      this.model.administrativeUnitSurvey?.histories ||
      this.model.administrativeUnitSurveyHistories ||
      []
    );
  }

  constructor(
    private surveyService: SurveyService,
    private notificationService: NotificationService,
    private authService: AuthService,
    private publicSurveyService: PublicSurveyService
  ) {
    super();
  }

  ngOnInit(): void {
    this.setBadges();
  }

  onSaveAdministrativeUnitSurveyMessage(message: AdministrativeUnitSurveyMessage) {
    message.administrativeUnitSurveyId = this.to?.administrativeUnitSurveyId;
    message.questionId = this.to?.question.id;

    if (this.to?.administrativeUnitSurveyId && message.questionId) {
      let request: SaveAdministrativeUnitSurveyMessage = {
        administrativeUnitSurveyId: this.to?.administrativeUnitSurveyId,
        commentType: "question",
        questionId: this.to?.question.id,
        narrative: message.narrative,
        isInternal: message.isInternal,
      };
      if (this.authService.isStateEducationAgencyUser) {
        this.surveyService.saveQuestionMessage(request).subscribe({
          next: (response) => {
            this.model.messages = [response, ...(this.model.messages || [])];
            if (this.model.administrativeUnitSurvey) {
              this.model.administrativeUnitSurvey.messages = [
                response,
                ...(this.model.administrativeUnitSurvey.messages || []),
              ];
            }
            this.setBadges();
          },
          error: (err) => this.notificationService.error(err.message),
        });
      } else {
        this.publicSurveyService.saveQuestionMessage(request).subscribe({
          next: (response) => {
            this.model.messages = [response, ...(this.model.messages || [])];
            if (this.model.administrativeUnitSurvey) {
              this.model.administrativeUnitSurvey.messages = [
                response,
                ...(this.model.administrativeUnitSurvey.messages || []),
              ];
            }
            this.setBadges();
          },
          error: (err) => this.notificationService.error(err.message),
        });
      }
    } else {
      // not a administrativeUnit survey, temporary save for survey manager testing reasons
      this.model.messages = [message, ...(this.model.messages || [])];
      this.setBadges();
    }
  }

  private setBadges() {
    if (this.model) {
      this.badges["lea-messages"] = this.messages.filter(
        (i) => !i.isInternal
      ).length;
      this.badges["internal-notes"] = this.messages.filter(
        (i) => i.isInternal
      ).length;
      this.badges["submission-history"] = this.administrativeUnitSurveyHistories.length;
      this.badges["action-required-comments"] = 0;
    }
  }
}
